import { render, staticRenderFns } from "./deleteColumnDialog.vue?vue&type=template&id=e31d7d14&scoped=true&lang=pug"
import script from "./deleteColumnDialog.vue?vue&type=script&lang=js"
export * from "./deleteColumnDialog.vue?vue&type=script&lang=js"
import style0 from "./deleteColumnDialog.vue?vue&type=style&index=0&id=e31d7d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31d7d14",
  null
  
)

export default component.exports